import React, { FC } from 'react';

import { Box, Grid, Text } from '@chakra-ui/react';
import { FieldArray } from 'formik';

import FormikInput from 'components/primitives/FormikInput';

import { EquipmentCountRow } from './equipmentCountRows';

type Props = {
  rows: EquipmentCountRow[];
  scrollContainerStyle?: React.CSSProperties;
};

/**
 * The Equipment section of a hub count (ClickUp 86bbmcwfb). Equipment is not
 * packed or boxed, so each SKU has just a count. FormikInput already stores a
 * number input as a number, so no onInput conversion is needed.
 */
export const EquipmentCountSection: FC<Props> = ({
  rows,
  scrollContainerStyle,
}) => (
  <Box mb={6}>
    <Text fontSize="lg" fontWeight="bold" mb={4}>
      Equipment
    </Text>
    {rows.length === 0 ? (
      <Text fontSize="sm">No equipment SKUs to count.</Text>
    ) : (
      <Box style={scrollContainerStyle}>
        <Grid templateColumns="repeat(2, 1fr)" gap={4}>
          <Text fontWeight="bold">Equipment SKUs</Text>
          <Text fontWeight="bold">Count(*)</Text>
        </Grid>
        <FieldArray name="equipment">
          {() =>
            rows.map((row, index) => (
              <Grid
                key={row.sku}
                templateColumns="repeat(2, 1fr)"
                gap={4}
                mt={2}>
                <FormikInput
                  name={`equipment.${index}.skuName`}
                  isReadOnly
                  value={row.skuName}
                />
                <FormikInput
                  name={`equipment.${index}.itemCount`}
                  type="number"
                  aria-label={`${row.skuName} count`}
                  onClick={(e: React.MouseEvent<HTMLInputElement>) =>
                    (e.target as HTMLInputElement).select()
                  }
                />
              </Grid>
            ))
          }
        </FieldArray>
      </Box>
    )}
  </Box>
);
